import { render, staticRenderFns } from "./PresentingComplaintHistoryStatus.vue?vue&type=template&id=b859072a&scoped=true&"
import script from "./PresentingComplaintHistoryStatus.vue?vue&type=script&lang=js&"
export * from "./PresentingComplaintHistoryStatus.vue?vue&type=script&lang=js&"
import style0 from "./PresentingComplaintHistoryStatus.vue?vue&type=style&index=0&id=b859072a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b859072a",
  null
  
)

export default component.exports